module.exports = function(data) {
  if ( window.DOMParser ) { // Standard
    tmp = new DOMParser();
    return tmp.parseFromString(data , "text/xml");
  } else { // IE
    xml = new ActiveXObject("Microsoft.XMLDOM");
    xml.async = "false";
    return xml.loadXML(data);
  }
}
